import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, QUESTION_ALL, QUESTION_TYPES, QUESTION_TYPES_COUNTS } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const QUESTIONS = GLOBAL_STATE

export const { reducer: questionsReducer } = createSlice({
  name: QUESTIONS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.questionAll.pending, state => {
        state[QUESTION_ALL].loading = true
      })
      .addCase(actionCreators.questionAll.rejected, (state, action) => {
        state[QUESTION_ALL].loading = false
        state[QUESTION_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.questionAll.fulfilled, (state, action) => {
        state[QUESTION_ALL].loading = false
        state[QUESTION_ALL].error = null
        state[QUESTION_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.questionTypes.pending, state => {
        state[QUESTION_TYPES].loading = true
      })
      .addCase(actionCreators.questionTypes.rejected, (state, action) => {
        state[QUESTION_TYPES].loading = false
        state[QUESTION_TYPES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.questionTypes.fulfilled, (state, action) => {
        state[QUESTION_TYPES].loading = false
        state[QUESTION_TYPES].error = null
        state[QUESTION_TYPES].data = action.payload
      })

    builder
      .addCase(actionCreators.questionTypesCounts.pending, state => {
        state[QUESTION_TYPES_COUNTS].loading = true
      })
      .addCase(actionCreators.questionTypesCounts.rejected, (state, action) => {
        state[QUESTION_TYPES_COUNTS].loading = false
        state[QUESTION_TYPES_COUNTS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.questionTypesCounts.fulfilled, (state, action) => {
        state[QUESTION_TYPES_COUNTS].loading = false
        state[QUESTION_TYPES_COUNTS].error = null
        state[QUESTION_TYPES_COUNTS].data = action.payload
      })

    builder.addCase(actionCreators.questionAllClear, state => {
      state[QUESTION_ALL] = defaultState()
    })

    builder.addCase(actionCreators.questionTypesClear, state => {
      state[QUESTION_TYPES] = defaultState()
    })

    builder.addCase(actionCreators.questionTypesCountsClear, state => {
      state[QUESTION_TYPES_COUNTS] = defaultState()
    })
  },
})
